import BringYourBestFootForward from "../../assets/images/Whitepapers/Bring-Your-Best-Foot-2048x1365.webp";
import DigitalTransformation from "../../assets/images/Whitepapers/Digital-2048x1365.webp";
import EmailMarketing from "../../assets/images/Whitepapers/Email-2048x1365.webp";
import CustomerDataPlatforms from "../../assets/images/Whitepapers/How-can-2048x1365.webp";
import OmnichanelRetail from "../../assets/images/Whitepapers/Mastring-2048x1365.webp";
import OvercomingBI from "../../assets/images/Whitepapers/Overcoming-1-2048x1365.webp";
import PerformanceMaximization from "../../assets/images/Whitepapers/Performnace-2048x1365.webp";
import ReinventingGlobalCapabilityCenters from "../../assets/images/Whitepapers/gcc.png";
import AIOnlyWorksIfYourDataWorks from "../../assets/images/Whitepapers/AI-Only-Works-If-Your-Data-Works.png";
import HowAgentforceIsRedesigningTheModernEnterprise from "../../assets/images/Whitepapers/How-Agentforce-is-Redesigning-the-Modern-Enterprise.png";

import AIOnlyWorksIfYourDataWorksPdf from "../../assets/images/Whitepapers/pdf/Comsense_AI_Data_Whitepaper.pdf";
import BringYourBestFootForwardPdf from "../../assets/images/Whitepapers/pdf/wp_Bring Your Best Foot Forward_ Elevating CX in the Retail Industry.pdf";
import DigitalTransformationPdf from "../../assets/images/Whitepapers/pdf/wp_Digital Transformation for Building Global Resilience in 2023.pdf";
import EmailMarketingPdf from "../../assets/images/Whitepapers/pdf/wp_Email Marketing Workflows You can Automate to Save Time and Drive Sales.pdf";
import CustomerDataPlatformsPdf from "../../assets/images/Whitepapers/pdf/wp_How can Customer Data Platforms help marketers adapt to a Cookieless Future.pdf";
import OmnichanelRetailPdf from "../../assets/images/Whitepapers/pdf/wp_Mastering the Art of Omnichannel in Retail_ Strategies for Exceptional Customer Experience.pdf";
import OvercomingBIPdf from "../../assets/images/Whitepapers/pdf/wp_Overcoming Strategic and Tactical BI challenges.pdf";
import PerformanceMaximizationPdf from "../../assets/images/Whitepapers/pdf/wp_Performance Maximization Campaigns_ Top Hacks to Boost Your Campaign Potential.pdf";
import ReinventingGlobalCapabilityCentersPdf from "../../assets/images/Whitepapers/pdf/wp_GCC.pdf";
import HowAgentforceIsRedesigningTheModernEnterprisePdf from "../../assets/images/Whitepapers/pdf/How_Agentforce_is_Redesigning_the_Modern_Enterprise.pdf";

export const whitepapers = [
  {
    id: 10,
    title: "How Agentforce is Redesigning the Modern Enterprise",
    slug: "how-agentforce-is-redesigning-the-modern-enterprise",
    excerpt:
      "",
    image: HowAgentforceIsRedesigningTheModernEnterprise,
    details: [
      "Agentforce is redefining how enterprises operate by turning software from a passive tool into an active digital teammate. This whitepaper explores how autonomous AI agents are being embedded into everyday business workflows, from customer service to sales and operations, to drive faster decisions and measurable outcomes.",
      "Learn how organizations are moving beyond simple automation to build agentic systems that reason, act, and collaborate with human teams, and what it takes to prepare your enterprise for this shift.",
    ],
    pdfFile: HowAgentforceIsRedesigningTheModernEnterprisePdf,
  },
  {
    id: 9,
    title: "AI Only Works If Your Data Works",
    slug: "ai-only-works-if-your-data-works",
    excerpt:
      "",
    image: AIOnlyWorksIfYourDataWorks,
    details: [
      "Organizations across industries are investing heavily in Generative AI, AI agents, predictive analytics, and intelligent automation. Yet despite unprecedented enthusiasm and spending, many AI initiatives fail to deliver meaningful business value.",
      "No matter how sophisticated an AI system may be, its outputs are fundamentally dependent on the quality, accuracy, completeness, and accessibility of the data it consumes. This paper explores why data quality is now the defining factor in AI success, the risks of ignoring data foundations, and the practical steps organizations must take to build AI-ready enterprises.",
    ],
    pdfFile: AIOnlyWorksIfYourDataWorksPdf,
  },
  {
    id: 8,
    title: "Beyond Cost Arbitrage: Reinventing GCCs for the AI Era",
    slug: "beyond-cost-arbitrage-reinventing-global-gccs-for-the-ai-era",
    excerpt: "",
    image: ReinventingGlobalCapabilityCenters,
    details: [""],
    pdfFile: ReinventingGlobalCapabilityCentersPdf,
  },
  {
    id: 1,
    title:
      "Performance Maximization Campaigns: Top Hacks to Boost Your Campaign Potential",
    slug: "performance-maximization-campaigns-top-hacks-to-boost-your-campaign-potential",
    excerpt: "",
    image: PerformanceMaximization,
    details: [""],
    pdfFile: PerformanceMaximizationPdf,
  },
  {
    id: 2,
    title: "Overcoming Strategic and Tactical BI Challenges",
    slug: "overcoming-strategic-and-tactical-bi-challenges",
    excerpt: "",
    image: OvercomingBI,
    details: [""],
    pdfFile: OvercomingBIPdf,
  },

  {
    id: 3,
    title:
      "Mastering the Art of Omnichannel in Retail: Strategies for Exceptional Customer Experience",
    slug: "mastering-the-art-of-omnichannel-in-retail-strategies-for-exceptional-customer-experience",
    excerpt: "",
    image: OmnichanelRetail,
    details: [""],
    pdfFile: OmnichanelRetailPdf,
  },
  {
    id: 4,
    title:
      "How can Customer Data Platforms help marketers adapt to a Cookieless Future?",
    slug: "how-can-customer-data-platforms-help-marketers-adapt-to-a-cookieless-future",
    excerpt: "",
    image: CustomerDataPlatforms,
    details: [""],
    pdfFile: CustomerDataPlatformsPdf,
  },
  {
    id: 5,
    title:
      "Email Marketing Workflows You can Automate to Save Time and Drive Sales",
    slug: "email-marketing-workflows-you-can-automate-to-save-time-and-drive-sales",
    excerpt: "",
    image: EmailMarketing,
    details: [""],
    pdfFile: EmailMarketingPdf,
  },
  {
    id: 6,
    title: "Digital Transformation for Building Global Resilience in 2023",
    slug: "digital-transformation-for-building-global-resilience-in-2023",
    excerpt: "",
    image: DigitalTransformation,
    details: [""],
    pdfFile: DigitalTransformationPdf,
  },

  {
    id: 7,
    title: "Bring Your Best Foot Forward: Elevating CX in the Retail Industry",
    slug: "bring-your-best-foot-forward-elevating-cx-in-the-retail-industry",
    excerpt: "",
    image: BringYourBestFootForward,
    details: [""],
    pdfFile: BringYourBestFootForwardPdf,
  },
];
